<template name="wareHouse">
  <div>
    <div class="wareContent">
      <div class="row top">
        <div v-if="isWareHouse" class="col-5 title-name">
          收发货信息
        </div>
        <div v-if="!isWareHouse" class="col-5 title-name">
          出门清单信息
        </div>
        <div class="col-7 up-down" @click="upAndDownshow = !upAndDownshow">
          <span v-if="this.upAndDownshow">收起<i class="iconfont icon-up"></i></span>
          <span v-if="!this.upAndDownshow">展开<i class="iconfont icon-down"></i></span>
        </div>
      </div>
      <div class="warehouse-box" v-if="upAndDownshow"  v-for="(item, index) in this.inviteGoodsList">
        <div class="warehouse-header">
          <div class="row">
            <div class="col-5">
              <h5 v-if="isWareHouse"><i class="iconfont icon-truck"></i>收发货清单</h5>
              <h5 v-if="!isWareHouse"><i class="iconfont icon-truck"></i>出门清单</h5>
            </div>
            <div class="col-7" v-show="item.isEditAndDelete">
              <button class="btn btn-default" :data-value="item.id" @click="deleteCheckDetail">删除</button>
              <button class="btn btn-red" @click="addWarehouse({
                id: item.id,
                ticketId: item.ticketId,
                goodsSerialNumber: item.goodsSerialNumber,
                isDangerous: item.isDangerous,
                goodsDetail: item.goodsDetail,
                goodsImages: item.goodsImages,
                checkUsers: item.checkUsers,
                isNewAdd: false,
                sealNumber: item.sealNumber,
                numberPlateList: item.numberPlateList,
                shipmentNumber: item.shipmentNumber
              })">修改</button>
            </div>
          </div>
        </div>
        <div class="warehouse-content">
          <ul>
            <li v-if="item.numberPlateList && item.numberPlateList.length > 0">{{$t('VisitCarNumber')}}:  <span v-for="car in item.numberPlateList">{{car.displayContent}} </span></li>
            <li v-if="item.goodsSerialNumber">货物编号:  {{item.goodsSerialNumber}}</li>
            <li>危险品:  <span :class="{'dangerous': item.isDangerous}">{{item.isDangerous == true ? '是' :  '否'}}</span></li>
            <li v-if="item.shipmentNumber">{{$t('ShippingNumber')}}:  {{item.shipmentNumber}}</li>
            <li v-if="item.sealNumber">{{$t('SealNumber')}}:  {{item.sealNumber}}</li>
            <li>核查清单:  {{item.goodsDetail}}</li>
            <li class="upload-img-list row" v-if="item.goodsImages!='' "><div>上传图片:  </div>
              <div @click="lookGoodImgs">
                <span :data-value="item.goodsImages" class="lookImgs">查看图片</span>
              </div>
            </li>
            <li v-for="(check, index) in item.checkUsers" v-if="item.checkStatus != 1">
              <span v-if="check.checkStatus != 1">审批人:  {{check.userName}}(<span class="dangerous">{{check.checkStatus == '1' ? '待审批' : check.checkStatus == '2' ? '已拒绝' : '已审批'}}</span>)
              </span>
            </li>
            <li v-for="(check, index) in item.checkUsers" v-if="item.checkStatus==1">
              <span>审批人:  {{check.userName}}(<span class="dangerous">{{check.checkStatus == '1' ? '待审批' : check.checkStatus == '2' ? '已拒绝' : '已审批'}}</span>)
              </span>
            </li>
            <li>填表人:  {{item.submitUserName}}</li>
            <li v-if="item.goodsCreateTime">填写时间:  {{item.goodsCreateTime}}</li>
            <li v-if="item.goodsCheckTime">审批时间:  {{item.goodsCheckTime}}</li>
            <li v-if="item.checkStatus == 2">拒绝原因:  {{item.rejectReason}}</li>
          </ul>
        </div>
        <div class="row status-btn" v-show="item.isChecker && item.checkStatus!=3">
          <div :data-value="item.id" @click="rejectCheckDetail">
            <span :data-value="item.id">拒绝</span>
          </div>
          <div :data-value="item.id" @click="agreeCheckDetail">
            <span :data-value="item.id">通过</span>
          </div>
        </div>
      </div>
      <div class="addWarehouse" v-if="this.isWareHouse" @click="addWarehouse({isNewAdd: true})">
        <i class="iconfont icon-add"></i><span>新增收发货清单</span>
      </div>
      <div class="addWarehouse" v-if="!this.isWareHouse" @click="addWarehouse({isNewAdd: true})">
        <i class="iconfont icon-add"></i><span>新增出门清单</span>
      </div>
    </div>
    <transition name="fade">
      <div class="visit-show" v-show="this.photoSwipeModal">
        <div>
          <photoSwipe ref="photoSwiper" @closePhoto="photoSwipeModal = !photoSwipeModal"></photoSwipe>
        </div>
      </div>
    </transition>
  </div>
</template>

<script type="text/javascript">
  import photoSwipe from '@/components/photoSwipe.vue';
  import Bus from '@/utils/Bus';
  export default {
    props: {
      inviteGoodsList: Array,
      routId: String,
      isGoodsListChecker: Boolean,
      newDeviceLayout: Boolean,
    },
    components: {
      photoSwipe,
    },
    created() {

    },
    data() {
      return {
       photoSwipeModal: false,
       isWareHouse: false,
       upAndDownshow: true,
      }
    },
    mounted() {
      const self = this;
      Bus.$on('to-trackingType', function (status) {
        self.isWareHouse = status == 2 || status == 3 ? true : false;
      })
    },
    methods: {
      deleteCheckDetail(e) {
        const GoodsListId = e.target.dataset.value;
        this.invitationId = this.routId;
        this.goodsListId = GoodsListId;
        if (this.invitationId && this.goodsListId) {
          this.deleteInvitationId = 'deleteSecurityCheckGoods';
          this.showComfirmDelete = true;
          const showObj = {
            currentTxt: 'deleteSecurityCheckGoods',
          };
          this.$emit('deleteSecurityCheckGoods', this.showComfirmDelete, this.deleteInvitationId, showObj, this.goodsListId)
          // this.$refs.detailDialogShow.loadDialogData(showObj);
        }
      },
      lookGoodImgs(e) {
        const imgs = e.target.dataset.value;
        const imgArr = imgs.split(',');
        if (imgArr) {
          this.photoSwipeModal = true;
          this.$refs.photoSwiper.loadPhoto(imgArr);
          this.lookImgs = true;
        }
      },
      rejectCheckDetail() {

      },
      agreeCheckDetail() {

      },
      addWarehouse(checkGoodsObj) {
        if (!checkGoodsObj.isNewAdd) {
          this.newWareHouseShow = true;
          this.$emit('newWareHouseShow', this.newWareHouseShow, checkGoodsObj,this.isWareHouse)
        } else {
          this.newWareHouseShow = true;
          this.$emit('newWareHouseShow', this.newWareHouseShow, '',this.isWareHouse)
        }
      },
    }
  }
</script>

<style lang="scss" scoped>
  .wareContent {
    padding: 20px;
    background: #fff;
    border-radius: 4px;
    box-shadow: 0 0 15px rgba(100,100,100,.1);
    margin-bottom: 20px;
    .top {
      margin: 0;
      padding: 0;
      margin-bottom: 15px;
      .title-name {
        font-size: 18px;
        font-weight: 600;
        color: #4a4a4a;
      }
      .up-down {
        text-align: right;
        padding: 0;
        cursor: pointer;
        span {
          font-size: 13px;
          color: #4a4a4a;
        }
        i {
          transform: scale(0.75, 0.75);
          margin-left: 5px;
          font-size: 14px;
          display: inline-block;
          margin-right: -2px;
        }
      }
    }
  }
  .warehouse-box {
    width: 100%;
    margin: 0 auto 20px;
    border-radius: 4px;
    background: #fff;
    padding: 15px 0;
    font-size: 13px;
    color: #4a4a4a;
    box-shadow: 0 0 15px rgba(100,100,100,.1);
  }
  .warehouse-header {
    padding: 0 20px 12px;
    margin-bottom: 12px;
    border-bottom: 1px solid rgba(101, 101, 101, 0.15);
    i {
      color: #e42029;
      margin-right: 5px;
      font-weight: normal;
    }
    h5 {
      font-size: 13px;
      font-weight: bold;
    }
    .col-5 {
      padding-right: 0;
      white-space: nowrap;
    }
    .col-7 {
      text-align: right;
    }
    .btn {
      height: 26px;
      border-radius: 13px;
      padding: 0 12px;
      line-height: 25px;
      font-size: 12px;
      & + .btn {
        margin-left: 10px;
      }
    }
  }
  .warehouse-content {
    padding: 0 20px;
    ul {
      padding: 0;
      list-style: none;
    }
    li {
      line-height: 2;
      span.dangerous {
        color: #e42029;
      }
    }
    .upload-img-list {
      word-break: break-all;
      margin: 0;
    }
    .lookImgs {
      cursor: pointer;
      text-decoration: underline;
      color: #e42029;
    }
  }
  .addWarehouse {
    height: 46px;
    line-height: 46px;
    border-radius: 5px;
    text-align: center;
    background-image: linear-gradient(82deg, #f36443, #e42029);
    cursor: pointer;
    margin: 20px 0 0;
    i {
      color: #fff;
      margin-right: 8px;
    }
    span {
      font-size: 15px;
      font-weight: 600;
      color: #fff;
    }
  }
</style>